import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API } from './api-config';

const { ONE_ID } = API_ENDPOINTS;
const { PIN } = ONE_ID;

export const ApiOneId = {
  fetchUserByPin: (pin: string | number) => {
    return API({
      path: PIN,
      method: 'GET',
      pathParams: { pin },
    });
  },
};
